import React from 'react';
import PropTypes from 'prop-types';
import { compose, withHandlers, withStateHandlers } from 'recompose';
import { Field, fieldInputPropTypes } from 'redux-form';
import SketchPicker from 'react-color/lib/Sketch';
import withToggle from '../hoc/withToggle';

const withPickerHandlers = compose(
  withHandlers({
    handleChangeComplete: ({ onChange }) => ({ hex }) => {
      onChange(hex);
    },
  }),
  withStateHandlers(({ value }) => ({ color: { hex: value } }), {
    setColor: () => ({ hex }) => ({ color: { hex } }),
  }),
);

const Picker = withPickerHandlers(({ onClose, setColor, handleChangeComplete, color }) => (
  <div className="c-colorpicker__popover">
    <div className="c-colorpicker__popover__cover" onClick={onClose} />
    <SketchPicker
      color={color}
      onChange={setColor}
      onChangeComplete={handleChangeComplete}
      presetColors={[]}
      disableAlpha
    />
  </div>
));

const InputInternals = ({
  input: { value, onChange },
  colorPickerIsOn,
  colorPickerOff,
  colorPickerToggle,
  wrapperClass,
  label,
}) => (
  <div className={wrapperClass}>
    <div className="c-label-new">{label}</div>
    <button
      className="c-input o-flexbox o-flexbox--content-align-center o-flexbox--justify-start"
      type="button"
      onClick={colorPickerToggle}
    >
      <div
        className="c-colorpicker__color"
        style={{ background: value }}
      />
      <div className="u-pl--">{value}</div>
    </button>
    {colorPickerIsOn && <Picker value={value} onChange={onChange} onClose={colorPickerOff} />}
  </div>
);

InputInternals.propTypes = {
  input: fieldInputPropTypes,
  colorPickerIsOn: PropTypes.bool.isRequired,
  colorPickerToggle: PropTypes.func.isRequired,
  colorPickerOff: PropTypes.func.isRequired,
  wrapperClass: PropTypes.string,
  label: PropTypes.node,
};

InputInternals.defaultProps = {
  input: { value: '', onChange: () => {} },
  wrapperClass: '',
  label: null,
};

const ColorInput = compose(
  withToggle('colorPicker'),
)(InputInternals);

const ColorPickerField = props => (
  <Field component={ColorInput} {...props} />
);

export default ColorPickerField;
